module.exports = __webpack_public_path__ + "static/img/carousel_2_klrq02_ar_4_3_w_400.cbf6a27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_2_klrq02_ar_4_3_w_400.jpg
// module id = qtmt
// module chunks = 0